import { createTheme, responsiveFontSizes } from '@material-ui/core/styles'
import colors from './colors'
import typography from './typography'
import palette from './palette'
import overrides from './overrides'
import props from './props'

const theme = createTheme({
  typography,
  palette,
  overrides,
  props,
  shape: {
    borderRadius: 0,
  },
  borders: {
    regular: `3px solid ${colors.black}`,
  },
  shadows: ['none', ...Array(24).fill('0px 8px 20px rgba(0,0,0, 0.1)')],
})

export default responsiveFontSizes(theme)
